export default "precision mediump float;\nuniform sampler2D tex;\nvarying vec2 uv;\nvoid main() {\n    gl_FragColor = texture2D(tex, uv).rgba;\n}\n"